export const ContactForm = (function () {

    let formToJson = function (form) {
        let object = {};
        let elements = form.querySelectorAll('input, select, textarea');

        [].forEach.call(elements, function (element) {
            if (!element.name) {
                return;
            }

            object[element.name] = element.value;
        });

        return JSON.stringify( object );
    };

    return function (wrapperElement) {
        let wrapper = wrapperElement;
        let form = wrapper.querySelector('.contact-form');
        let checkboxes = form.querySelectorAll('input[type="checkbox"]:not(.js-global-projects-inputs):not(.checkbox-group)[required]');
        let checkboxesGroups = form.querySelectorAll('.field-block');
        let inputs = form.querySelectorAll('input[data-required]');
        let globalPopup = document.getElementById('global-popup-contact');
        let formLabel = form.dataset.label;
        let competition = form.dataset.competition;

        window.formLabel = formLabel;

        form.addEventListener('submit', function (e) {
            e.preventDefault();

            this.send();
        }.bind(this));

        this.vitecRegistration = function(){
            console.log('VITEC');

            let estateIds = {
                'none':'D410A3AF-6854-4E21-9B1B-2F9F28C84985', //Garasjeveien 5
                'vannkunsten':'D93B2574-C16E-4901-8F3F-876CADD2E852', //Sjøbergvegen 32A
                'clemenskvartalet':'8D6012A4-7A8A-4533-B37F-A500ABA6CB82', //Huldreringen 6B
                'dronninglunden':'8C826B5B-A3AE-43E9-80E5-9261FFDF4D88', //Sandgata 71
                'eufemias plass syd':'7F7342D4-1B74-45ED-B21E-A99F32D708CF', //Gryta 2B
                'eufemias plass vest':'782902B6-5BF7-49C4-A24C-F3E2D8BCD140' //Pilestredet park 28
            }
            let estate = ((form.project_ref != undefined && form.project_ref.value != undefined) ? form.project_ref.value.toLowerCase() : '');
            //let estateId = estateIds[prop] || estateIds.none;
            //console.log('estateId:',estateId);
            //estateId = estateIds.none;

            //let bAuth = 'Basic ' + btoa('daytwo:edMuv3maJtCE9t227fnt7CgSRaPPf6hyaXCJyuwzGVGCBkxjxJ');

            let fData = new FormData();

            if (form && form.firstName) {
                fData.append('contactType',0);
                fData.append('firstName',form.firstName.value);
                fData.append('lastName',form.lastName?.value ? form.lastName.value : '');
                fData.append('mobilePhone',form.phone?.value ? form.phone.value : '');
                fData.append('username',form.username.value);
                fData.append('user_address',form.user_address.value);
                fData.append('description',form.description.value);

                if (competition) {
                    fData.append('competition', 1);
                    fData.append('sub', form?.sub?.checked ? form.sub.checked : false);
                    // fData.append('sub', true); // Always true since we removed or disabled checkbox
                    fData.append('navneforslag', form.navneforslag.value);
                    fData.append('body', form.navnDescription.value);
                }
            }
            if(form.integration){
                fData.append('integration', form.integration.value);
            }
            if(form.knipsId){
                fData.append('knipsId', form.knipsId.value);
            }

            fData.append('estateLabel',estate);
            fData.append('email',form.fromEmail.value);
            fData.append('keepMeInformed',true);
            fData.append('source',"osu.no");
            fData.append('action','vitecbroker/broker/level-up');
            fData.append('CRAFT_CSRF_TOKEN',form.querySelector('[name="CRAFT_CSRF_TOKEN"]').value);
            fData.append('makeAs', form.makeAs ? form.makeAs.checked : form.makeAsPre?.value);
            fData.append('noVitec', form.makeAsPre ? 1 : 0);

            // console.log('CRAFT_CSRF_TOKEN',form.querySelector('[name="CRAFT_CSRF_TOKEN"]').value);

            this.showOverlay();

            fetch('/', {
                method: 'POST',
                headers: {'Accept': 'application/json'},
                body: fData

            }).then( function(res){ return res.json(); })
                .then(function(result){
                    if(result.success && result.result && (result.result?.result?.competition || result.result.length > 0 || result.result?.success)){
                        this.showSuccess();

                        if (window.dataLayer) {
                            window.dataLayer.push({
                                'event': 'eventTracking',
                                'eventCategory': 'Meld interesse',
                                'eventAction': 'sent',
                                'eventLabel': formLabel
                            });
                        }

                        if (window.d2_cookies) {
                            window.d2_cookies.subscriptionRegistered();
                        }

                        if (formLabel === 'popup' && globalPopup) {
                            setTimeout(function () {
                                globalPopup.classList.remove('active');
                            }, 3000);
                        }
                    }else{
                        this.showError();
                    }
                }.bind(this))
                .catch(function(e){
                    console.log(e);
                    this.showError();
                }.bind(this));


            /*fetch('/', {
                method: 'POST',
                headers: {'Accept': 'application/json'},
                body: fData

            }).then( function(res){ return res.json(); })
            .then(function(result){
              if(result.success && result.data.scalar && result.data.scalar.length > 30 && result.data.scalar.length < 40){
                console.log('vitec registered');
              }else{
                console.log('vitec not registered');
              }
            })
            .catch(function(e){
              console.log('error on vitec registration',e);
            })*/
        }

        this.send = function () {

            if (form && (form.firstName && form.lastName)) {
                form.fromName.value = form.firstName.value + " " + form.lastName.value;
            } else if (form && form.firstName) {
                form.fromName.value = form.firstName.value;
            }

            if (!this.validate()) {
                return;
            }

            this.showOverlay();
            let fData = new FormData(form);
            this.vitecRegistration();
            //fData.delete('firstName]');
            //fData.delete('lastName]');
            /*fetch('/', {
                method: 'POST',
                headers: { 'Accept': 'application/json' },
                body: fData
            }).then(function (res) { return res.json() })
            .then(function (result) {

                if (result.success) {
                    this.showSuccess();

                    if (window.dataLayer) {
                        window.dataLayer.push({
                            'event': 'eventTracking',
                            'eventCategory': 'Meld interesse',
                            'eventAction': 'sent',
                            'eventLabel': formLabel
                        });
                    }

                    if (window.d2_cookies) {
                        window.d2_cookies.subscriptionRegistered();
                    }

                    if (formLabel === 'popup' && globalPopup) {
                        setTimeout(function () {
                            globalPopup.classList.remove('active');
                        }, 3000);
                    }

                    this.vitecRegistration();

                } else {
                    this.showError();
                }
            }.bind(this));*/
        };

        this.validate = function () {
            let valid = true;
            let _self = this;

            [].forEach.call(checkboxes, function (checkbox) {
                if (checkbox.checked) {
                    checkbox.classList.remove('invalid');
                } else {
                    checkbox.classList.add('invalid');
                }

                valid = valid && checkbox.checked;
            });

            [].forEach.call(checkboxesGroups, function (checkboxesGroup) {
                let checkedOptions = checkboxesGroup.querySelectorAll('.checkbox-group:checked');
                let allOptions = checkboxesGroup.querySelectorAll('.checkbox-group');
                if(checkedOptions.length == 0){
                    valid = false;
                    [].forEach.call(allOptions, function (option) {
                        option.classList.add('invalid');
                    });
                }else{
                    [].forEach.call(allOptions, function (option) {
                        option.classList.remove('invalid');
                    });
                }
            });

            [].forEach.call(inputs, function (input) {
                let noError = true;
                if (!input.value) {
                    input.classList.add('invalid');
                    noError = false;
                } else if (input.dataset.phone === '1' && (!_self.validatePhone(input.value) || input.value.length < 8)) {
                    input.classList.add('invalid');
                    noError = false;
                } else if (input.dataset.email === '1' && !_self.validateEmail(input.value)) {
                    input.classList.add('invalid');
                    noError = false;
                } else {
                    input.classList.remove('invalid');
                }

                valid = valid && input.value && noError;
            });

            return valid;
        };

        this.validateEmail = function(email) {
            let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        };

        this.validatePhone = function(phone) {
            let re = /^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/g;
            return re.test(phone);
        };

        this.showOverlay = function () {
            wrapper.classList.add('overlay');
            wrapper.classList.remove('success');
            wrapper.classList.remove('error');
        };

        this.showSuccess = function () {
            wrapper.classList.add('success');
            wrapper.classList.remove('overlay');
            wrapper.classList.remove('error');
        };

        this.showError = function () {
            wrapper.classList.add('error');
            wrapper.classList.remove('overlay');
            wrapper.classList.remove('success');
            setTimeout(function(){
                wrapper.classList.remove('error');
            },3000);
        };
    };
} ());